// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
import {
  BuildRiskCoverageItem,
  BuildRiskCoverageItemFromJSON,
  BuildRiskCoverageItemToJSON,
} from "./";

/**
 * Risk coverage scoped to a build (TCV-6726): a risk is \"covered\" when at least one of its linked test cases was executed (any non-unexecuted status) in a test plan linked to the build. Uses Risk-Based Testing.
 * @export
 * @interface BuildRiskCoverage
 */
export interface BuildRiskCoverage {
  /**
   *
   * @type {number}
   * @memberof BuildRiskCoverage
   */
  totalRisks: number;
  /**
   * Risks with at least one linked test case executed against this build.
   * @type {number}
   * @memberof BuildRiskCoverage
   */
  coveredRisks: number;
  /**
   * High or critical risks with no executed test in this build. Drives the \"high risk has no executed test\" warning banner.
   * @type {number}
   * @memberof BuildRiskCoverage
   */
  uncoveredHighCount: number;
  /**
   *
   * @type {Array<BuildRiskCoverageItem>}
   * @memberof BuildRiskCoverage
   */
  risks: Array<BuildRiskCoverageItem>;
}

export function BuildRiskCoverageFromJSON(json: any): BuildRiskCoverage {
  return {
    totalRisks: json["total_risks"],
    coveredRisks: json["covered_risks"],
    uncoveredHighCount: json["uncovered_high_count"],
    risks: (json["risks"] as Array<any>).map(BuildRiskCoverageItemFromJSON),
  };
}

export function BuildRiskCoverageToJSON(value?: BuildRiskCoverage): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    total_risks: value.totalRisks,
    covered_risks: value.coveredRisks,
    uncovered_high_count: value.uncoveredHighCount,
    risks: (value.risks as Array<any>).map(BuildRiskCoverageItemToJSON),
  };
}
